

import { mapState } from 'vuex'
import utils from '@/components/tools/utils'
import time from '@/components/tools/time'

export default {

  props: {
    endingAt: {
      type: Number,
      default: undefined
    },
    startingAt: {
      type: Number,
      default: undefined
    },
    status: {
      type: String,
      default: undefined
    },
    long: {
      type: Boolean,
      default: true
    },
    entityId: {
      type: Number,
      default: undefined
    },
    renegEndingAt: {
      type: String,
      default: undefined
    },
    anrOfferAboveTargetPrice: {
      type: Boolean,
      default: false
    },
    onCountdownFinish: {
      type: Function,
      default: () => {
      }
    }
  },
  data: () => ({
    now: Date.now(),
    interval: undefined
  }),

  computed: {
    ...mapState('general', ['differenceToServerTime']),
    ready () {
      return this.endingAt && this.startingAt && this.status
    },

    leftTimeEndingAt () {
      const now = Date.now() - this.differenceToServerTime

      return this.endingAt - now
    },

    leftTimeStartingAt () {
      const now = Date.now() - this.differenceToServerTime

      return this.startingAt - now
    },

    lateOfferEndingAt () {
      if (this.status === 'recd_late_offer') {
        return time.parseDate(this.renegEndingAt)
      } else {
        return undefined
      }
    },

    leftTimeLateOfferEndingAt () {
      const now = Date.now() - this.differenceToServerTime

      return this.lateOfferEndingAt - now
    }
  },

  mounted () {
    const that = this
    this.interval = setInterval(function () {
      that.now = Date.now() - that.differenceToServerTime
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    formatDate (value) {
      return utils.formatDate(value, this.$i18n.locale)
    },
    inWords (timeObj) {
      return time.inWords(timeObj, this)
    },

    inShortWords (timeObj) {
      return time.inShortWords(timeObj, this)
    }

  }
}

